import { createClient } from "contentful";

const client = createClient({
  space: "a8n6wrrroowp",
  accessToken: "qTm9wm4fjFnfNGO-Ijbt5thWziZ3Umkkg2PWOJLow4A",
});

export default client;
